import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyForloop = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="65%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python – For Loops</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    The for loop in Python is different from other programming
                    languages like C and Java. A for loop in Python is used to
                    iterate over a sequence or a collection (list, tuple,
                    dictionary, etc.).
                  </p>
                </div>
                {/* <br />
                <br />

                <h1 className="py_h1">The While Loop in Python</h1>
                <p>
                  The while loop is a condition-controlled loop, it means it
                  will repeat until a specific condition is met. The statements
                  which you want to repeat must be indented, after a while
                  condition.
                </p> */}
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Syntax of For Loop</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     for <variable> in <sequence>:
                        #statements to be executed
                        #multiple statements can executeS
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
                <p>
                  In the above for loop syntax, the variable takes the next
                  value from sequence until the last sequence and repeats the
                  statements.
                </p>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Python For Loop with the List</h1>

                <hr style={{ color: "white" }} />
                <p>
                  For loops can use with any kind of collections in Python like
                  list, tuple, dictionary, etc.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     language=['Python','Java','C','C++','PHP']
                     for lang in language:
                         print(lang)
                      
                     #the variable lang takes the value from the List language one by one and print them until the last value
                       `}
                    </code>
                  </pre>
                  <p>
                    The above program will print 1 to 10 as output. An initial
                    value of a variable n is 1, the value of n is less than 10,
                    so the condition is true, after that it prints the value of
                    n, after that increase the value by 1. Every time it checks
                    the condition and repeats the statements until the condition
                    is not false.
                  </p>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     numbers=[11,22,33,44,55,66,77]
                     sum=0
                     for n in numbers:
                         sum+=n
                     print("Total :",sum)
                      
                     #the variable n takes the value from the List numbers one by one and calculate the sum until the last value
                       `}
                    </code>
                  </pre>
                </div>

                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">The range() Function</h1>

                <hr style={{ color: "white" }} />
                <p>
                  The range() function in Python generates a sequence of numbers
                  starting from 0 to n-1. The syntax of range function in Python
                  is range (start, stop, step).
                </p>

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <ul>
                    <li>
                      start (optional) – Starting number of range(). the default
                      value is 0 if we not provide.
                    </li>
                    <li>
                      stop (required) – Endpoint of the range() function..
                    </li>
                    <li>
                      step (optional) – Step size or increment. The default
                      value is 1 if we not provide.
                    </li>
                  </ul>
                  <br />
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example: Use of range() function in Python</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     a=range(5)      #start with 0
                     b=range(0,5)    #endpoint is 5
                     c=range(2,7)    #step size is 1
                     d=range(2,11,2) #step size is 2
                     e=range(5,0,-1) #step size is -1
                      
                     print(a)
                     print(list(a))
                      
                     print(b)
                     print(list(b))
                      
                     print(c)
                     print(list(c))
                      
                     print(d)
                     print(list(d))
                      
                     print(e)
                     print(list(e))
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
                <div className="bg-primary">
                  <p>
                    Note: list() – In Python, list() function takes sequence
                    type as a parameter and converts it into List.
                  </p>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Python For Loop with the Range</h1>
                <hr style={{ color: "white" }} />
                <p>
                  We can use range() with for loop to generate a sequence of
                  numbers.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example: Example of range function with for loop.</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     #It will print 0 to 4
                     num=range(5)
                     for i in num:
                         print(i)
                          
                     #or you can write above example like this
                     for i in range(5):
                         print(i)
                      
                     #It will print 1 to 4
                     for i in range(1,5):
                         print(i)
                      
                     #It will print 2,4,6,8
                     for i in range(2,10,2):
                         print(i)
                      
                     #It will print 10 to 1
                     for i in range(10,0,-1):
                         print(i)
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
